import './CoralDomain.scss'

import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { mapCoralWebDomain } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { CoralDomainFlipCard } from '../../../coral-library/cards/FlipCards/CoralDomainFlipCard/CoralDomainFlipCard'

type CoralDomainProps = ReturnType<typeof mapCoralWebDomain>

export const CoralDomain: FC<CoralDomainProps> = (props) => {
  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-domain'}>
        <CoralHeading description={props.description} header={props.header} />
        <div className={'coral-domain__container'}>
          {props.flip_cards.map((card, id) => (
            <CoralDomainFlipCard key={id} {...card} />
          ))}
        </div>
      </div>
    </div>
  )
}
